import React, { useState } from "react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { FilterButton } from "../../styles/styles_input_pesquisas";
import {

	Dumbbell,
	VenusAndMars,
	BriefcaseBusiness,
	PersonStanding,
	ListCheck,
	SquareUser,
	DoorOpen,
	PencilRuler
} from "lucide-react";
import DatePickerWithRange from "./DataPicker";
import MultiSelect from "./MultiSelect";
import { useSelector } from "react-redux";
import { TextsProps } from "../../database/txt.interface";
import { FiltroTypes } from "./Funcs";
import Tags from "./Tags";
import Close from "../../assets/kinologyIcons/svg/close.svg";
import { endOfMonth, startOfMonth } from "date-fns";


interface FilterProps {
	icon: any,
	onFilterChange: (selected: FiltroTypes) => void;
	defaultFilter: FiltroTypes,
	GraphType: string,
	Cleanedfilter?: ()=> void
};

const Filter: React.FC<FilterProps> = ({ icon, onFilterChange,Cleanedfilter, defaultFilter, GraphType }) => {

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);

	let exercicios: any = useSelector(
		(state: any) => state.exercicios.exercicios
	);

	let cargos_dynalabs = useSelector(
		(state: any) => state.dashboard.cargos
	);

	let protocolos_dynalabs = useSelector(
		(state: any) => state.manage_protocol.protocolos
	);

	let avaliadores = useSelector(
		(state: any) => state.dashboard.avaliadores
	);

	let etiquetas = useSelector(
		(state: any) => state.dashboard.etiquetas
	);

	let entrance_door_data = useSelector(
		(state: any) => state.dashboard.entrance_door_data
	);

	let gerencias = useSelector((state: any) => state.dashboard.gerencias);

	const articulacoes = [
		{
			label: "CERVICAL",
			value: "CERVICAL"
		},
		{
			label: "COTOVELO",
			value: "COTOVELO"
		},
		{
			label: "JOELHO",
			value: "JOELHO"
		},
		{
			label: "OMBRO",
			value: "OMBRO"
		},
		{
			label: "PUNHO",
			value: "PUNHO"
		},
		{
			label: "QUADRIL",
			value: "QUADRIL"
		},
		{
			label: "TORNOZELO",
			value: "TORNOZELO"
		},
	]

	const sexos = [
		{
			label: "Masculino",
			value: "M"
		},
		{
			label: "Feminino",
			value: "F"
		}
	]

	const condicionamentos = [
		{
			label: current_language?.menu_lateral_atleta,
			value: 1
		},
		{
			label: current_language?.menu_lateral_ativo,
			value: 2
		},
		{
			label: current_language?.menu_lateral_pos_operatorio,
			value: 3
		},
		{
			label: current_language?.menu_lateral_sedentario,
			value: 4
		},
		{
			label: current_language?.menu_lateral_idoso,
			value: 5
		},


	]

	const alteracoes = [
		{
			label: "Sem alterações",
			value: "positivo",
			color: "#0CD100"
		},
		{
			label: "Alterações Leves",
			value: "intermediario",
			color: "#FFC530"
		},
		{
			label: "Alterações Significativas",
			value: "negativo_1",
			color: "#E57E00"
		},
		{
			label: "Alterações Graves",
			value: "negativo_2",
			color: "#D12600"
		},
	]

	if (exercicios.length > 0) {
		exercicios = exercicios.map((exercicio: any) => {
			exercicio.label = exercicio?.EXERCICIO_TITULO_PT;
			exercicio.value = exercicio.ID_EXERCICIO
			return exercicio;
		})
	}

	if (cargos_dynalabs.length > 0) {
		cargos_dynalabs = cargos_dynalabs.map((cargo: any) => {
			cargo.label = cargo.CARGO_TITULO
			cargo.value = cargo.ID_CARGO
			return cargo
		})
	}

	if (protocolos_dynalabs.length > 0) {
		protocolos_dynalabs = protocolos_dynalabs.map((protocolo: any) => {
			protocolo.label = protocolo.PROTOCOLO_TITULO_PT
			protocolo.value = protocolo.ID_PROTOCOLO
			return protocolo
		})
	}

	if (etiquetas.length > 0) {
		etiquetas = etiquetas.map((etiqueta: any) => {
			etiqueta.label = etiqueta.ETIQUETA_NOME
			etiqueta.value = etiqueta.ID_ETIQUETA
			return etiqueta
		})
	}

	if (avaliadores.length > 0) {
		avaliadores = avaliadores.map((avaliador: any) => {
			avaliador.label = avaliador.USUARIO_NOME
			avaliador.value = avaliador.ID_USUARIO
			return avaliador
		})
	}

	if (entrance_door_data.length > 0) {
		entrance_door_data = entrance_door_data.map((door: any) => {
			door.label = door.PORTA_ENTRADA_TITULO
			door.value = door.ID_PORTA_ENTRADA
			return door
		})
	}

	if (gerencias.length > 0) {
		gerencias = gerencias.map((gerencia: any) => {
			gerencia.label = gerencia.GERENCIA_TITULO
			gerencia.value = gerencia.ID_GERENCIA
			return gerencia
		})
	}


	let current_filters: FiltroTypes = defaultFilter ? defaultFilter : {};

	const mesesAbreviados = [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];


	const getLastThreeMonthsAbbr = () => mesesAbreviados.map((m, i, a) => a[(new Date().getMonth() - 2 + i + 12) % 12]).slice(0, 3);

	const ano_atual = new Date().getFullYear();
	

	const panelSelecionado = useSelector((state: any)=> state.dashboard.current_panel_selected);
	
	const handleClearFilters = () => {
		
		const mesIndex = mesesAbreviados.findIndex(m => m.toLowerCase() === panelSelecionado.toLowerCase());

		if (mesIndex === -1) {
			return;
		}

		const from = startOfMonth(new Date(ano_atual, mesIndex));
		const to = endOfMonth(new Date(ano_atual, mesIndex));

		const current_filters = {
			data: { from, to }
		};

		 onFilterChange(current_filters)

		 setOpen(false);
		 Cleanedfilter?.()

	}

	const handleExerciseChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.exercicio = selected;
		} else {
			delete current_filters.exercicio
		}
	};

	const handleProtocolsChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.protocolo = selected;
		} else {

			delete current_filters.protocolo
		}
	};

	const handleCargosChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.cargo = selected;
		} else {
			delete current_filters.cargo
		}
	};

	const handleSexoChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.sexo = selected;
		} else {
			delete current_filters.sexo
		}
	};

	const handleCondicionamentoChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.condicionamento = selected;
		} else {
			delete current_filters.condicionamento
		}
	};

	const handleEtiquetasChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.etiqueta = selected;
		} else {
			delete current_filters.etiqueta
		}
	};

	const handleAvaliadorChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.avaliador = selected;
		} else {
			delete current_filters.avaliador
		}
	};

	const handleArticulacaoChange = (selected: any) => {
		if (selected.length > 0) {
			current_filters.articulacao = selected;
		} else {
			delete current_filters.articulacao
		}
	};

	const handleEntranceDoor = (selected: any) => {
		if (selected.length > 0) {
			current_filters.entrance_door_data = selected;
		} else {
			delete current_filters.entrance_door_data
		}
	};

	const handleGerencias = (selected: any) => {
		if (selected.length > 0) {
			current_filters.gerencias = selected;
		} else {
			delete current_filters.gerencias
		}
	};

	const handleAlteracoes = (selected: any) => {
		if (selected.length > 0) {
			current_filters.alteracoes = selected;
		} else {
			delete current_filters.alteracoes
		}
	};

	const handleDataPickerChange = (selected: any) => {
		current_filters.data = selected;
	};

	const ApplyFilter = (() => {
		if ((current_filters.mes || current_filters.ano) && current_filters.data) {
			delete current_filters.ano
			delete current_filters.mes
		}
		onFilterChange(current_filters)
		setOpen(false)
	})

	const [open, setOpen] = useState(false)



	return (
		<AlertDialog open={open} onOpenChange={setOpen}>
			<AlertDialogTrigger style={{ marginLeft: "1rem" }}>
				<img style={{ width: '1.5rem', height: '1.5rem' }} src={icon} alt="" />
			</AlertDialogTrigger>
			<AlertDialogContent
				className="w-[100%] bg-white flex flex-col items-center justify-center p-10"
				style={{ width: "60rem" }}
			>
				<AlertDialogDescription className="text-center mb-4" style={
					{ color: '#9497A4', fontSize: '1rem' }
				}>
					Filtros
				</AlertDialogDescription>

				<AlertDialogCancel
					style={{ position: "absolute", top: "1rem", right: "1rem", border: 'none', boxShadow: 'none' }}
				>
					<FilterButton
						onClick={() => {
							return false;
						}}
						src={Close}
					/>
				</AlertDialogCancel>
				<div style={{ width: '100%' }}>

					<AlertDialogDescription
						className="text-center mb-4"
						style={{ color: "#00A377", textAlign: 'end', textDecoration: 'underline', cursor: 'pointer' }}
						onClick={handleClearFilters}
					>
						Limpar
					</AlertDialogDescription>
				</div>
				<div className="flex flex-wrap gap-4 w-full">
					<DatePickerWithRange onPickerChange={handleDataPickerChange} />
					{/*
					<MultiSelect title={"Por evento"} IconLucide={CalendarSync} data={options} Searchable />

					<MultiSelect title={"Indicadores"} IconLucide={Gauge} data={options} Searchable />
					<MultiSelect title={"Valores de referência"} IconLucide={FileSearch2} data={options} Searchable />
					*/}
					{GraphType == "Indicadores Antagônicos" ?
						<MultiSelect title={"Articulações"} IconLucide={PersonStanding} data={articulacoes} CurrentSelected={defaultFilter?.articulacao} onSelectChange={handleArticulacaoChange} Searchable />
						:
						<>
							<MultiSelect title={"Protocolo"} IconLucide={ListCheck} data={protocolos_dynalabs} CurrentSelected={defaultFilter?.protocolo} onSelectChange={handleProtocolsChange} Searchable />
							<MultiSelect title={"Exercício"} IconLucide={Dumbbell} data={exercicios} CurrentSelected={defaultFilter?.exercicio} onSelectChange={handleExerciseChange} Searchable />
						</>
					}
					<MultiSelect title={"Cargo"} IconLucide={BriefcaseBusiness} data={cargos_dynalabs} CurrentSelected={defaultFilter?.cargo} onSelectChange={handleCargosChange} Searchable />
					<MultiSelect title={"Sexo"} IconLucide={VenusAndMars} data={sexos} CurrentSelected={defaultFilter?.sexo} onSelectChange={handleSexoChange} Searchable />
					<MultiSelect title={"Nível de cond."} IconLucide={PersonStanding} data={condicionamentos} CurrentSelected={defaultFilter?.condicionamento} onSelectChange={handleCondicionamentoChange} Searchable />
					<MultiSelect title={"Avaliador"} IconLucide={SquareUser} data={avaliadores} CurrentSelected={defaultFilter?.avaliador} onSelectChange={handleAvaliadorChange} Searchable />
					<MultiSelect title={"Porta de entrada"} IconLucide={DoorOpen} data={entrance_door_data} CurrentSelected={defaultFilter?.entrance_door_data} onSelectChange={handleEntranceDoor} Searchable />
					<MultiSelect title={"Gerências"} IconLucide={PencilRuler} data={gerencias} CurrentSelected={defaultFilter?.gerencias} onSelectChange={handleGerencias} Searchable />
					{['Alterações encontradas', 'Contagem de risco por protocolo', 'Contagem de risco por cargo']?.includes(GraphType) &&
					<MultiSelect title={"Alterações"} IconLucide={"Alteracoes"} data={alteracoes} CurrentSelected={defaultFilter?.alteracoes} onSelectChange={handleAlteracoes} Searchable />
					}

					{/*
					<MultiSelect title={"Tempo de empresa"} IconLucide={Clock} data={options} Searchable />
					
					*/}

				</div>

				<Tags data={etiquetas} CurrentSelected={defaultFilter?.etiqueta} onSelectChange={handleEtiquetasChange} />

				<AlertDialogAction
					style={{
						width: "100%",
						backgroundColor: "#000E4B",
						color: '#FAFAFA',
						fontSize: '1rem',
						padding: "1.3rem",
						borderRadius: '12px',
						marginTop: '2rem'
					}}
					onClick={ApplyFilter}
				>
					Aplicar
				</AlertDialogAction>
			</AlertDialogContent>
		</AlertDialog>
	);
};



export default Filter;
